import React, { useEffect, useState } from 'react';

const searchIcon = () => (
  <svg viewBox="0 0 19 19" className="w-5 h-5">
    <path fill="currentColor" d="M13.1458 12.0833H12.3229L12.0312 11.8021C13.0521 10.6146 13.6667 9.07292 13.6667 7.39583C13.6667 3.65625 10.6354 0.625 6.89583 0.625C3.15625 0.625 0.125 3.65625 0.125 7.39583C0.125 11.1354 3.15625 14.1667 6.89583 14.1667C8.57292 14.1667 10.1146 13.5521 11.3021 12.5312L11.5833 12.8229V13.6458L16.7917 18.8438L18.3438 17.2917L13.1458 12.0833ZM6.89583 12.0833C4.30208 12.0833 2.20833 9.98958 2.20833 7.39583C2.20833 4.80208 4.30208 2.70833 6.89583 2.70833C9.48958 2.70833 11.5833 4.80208 11.5833 7.39583C11.5833 9.98958 9.48958 12.0833 6.89583 12.0833Z" />
  </svg>
);

const closeIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4">
    <path fill="currentColor" d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"></path>
  </svg>
);

const Search = ({
  markers,
  visibleMarkers,
  setVisibleMarkers,
  sidebarMarkers,
  setSidebarMarkers,
  selectedMarkerButton,
  setSelectedMarkerButton,
  searchInput,
  setSearchInput,
  setActiveMarkerGroup,
  ...props
}) => {
  const [icon, setIcon] = useState(searchIcon);

  const getFilteredMarkers = (m) => {
    const filteredMarkers = {};

    Object.keys(m).forEach((markerType) => {
      filteredMarkers[markerType] = markers[markerType].filter((marker) => {
        const { properties } = marker;
        const { name } = properties;
        return name.toLowerCase().includes(searchInput.toLowerCase());
      });
    });

    return filteredMarkers;
  };

  const searchItems = () => {
    if (searchInput !== '') {
      setVisibleMarkers(getFilteredMarkers(markers));
      setSidebarMarkers(getFilteredMarkers(sidebarMarkers));
    } else {
      setVisibleMarkers(markers);
      setSidebarMarkers(markers);
    }
  };

  useEffect(() => {
    searchItems();

    if (searchInput !== '') {
      setIcon(closeIcon());
      setActiveMarkerGroup('');

      if (selectedMarkerButton) {
        setSelectedMarkerButton(false);
      }
    } else {
      setIcon(searchIcon());
      setSelectedMarkerButton(false);
    }
  }, [searchInput]);

  return (
    <div {...props}>
      <div className="relative flex justify-end pb-2 border-b border-white">
        <input
          className={[
            'block',
            'w-full',
            'text-base lg:text-lg',
            'bg-transparent',
            'placeholder-white hocus:placeholder-primary',
            'outline-none',
            'transition',
          ].join(' ')}
          value={searchInput}
          onChange={({ target }) => {
            setSearchInput(target.value);
          }}
          onFocus={() => {
            setActiveMarkerGroup('');

            if (searchInput === '') {
              setVisibleMarkers(markers);
            }
          }}
          placeholder="Search the map"
        />
        <button
          className="absolute flex items-center justify-center w-5 pb-2 h-full"
          aria-label={searchInput ? "Clear search" : "Search"}
          onClick={() => setSearchInput('')}
        >
          <span className="flex">{icon}</span>
        </button>
      </div>
    </div>
  );
};

export default Search;
